<!-- Modal -->
<div
  class="modal fade"
  [id]="element.id + '_modal'"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <ng-content select=".dialog-header"></ng-content>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-content select=".dialog-body"></ng-content>
      </div>
      <div class="modal-footer">
        <ng-content select=".dialog-footer"></ng-content>
      </div>
    </div>
  </div>
</div>
